import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zeroNumberFormatter'
})
export class ZeroNumberFormatterPipe implements PipeTransform {
  public transform(value: number, fmt: string, def: string = '-'): any {
    if (value) {
      return formatNumber(value, 'en', fmt);
    } else {
      return def;
    }
  }
}
